<template>
    <div class="CourseApplyDetailsWarp">
        <div class="titleBox">报名详情</div>
        <div class="singupdialogcenter">
            <div class="courseBox1">
                <div class="courseinfo">
                    <span class="text">课程编码</span>
                    <span>{{this.busCourseData.trainCode}}</span>
                </div>
                <div class="courseinfo">
                    <span class="text">课程名称</span>
                    <span>{{this.busCourseData.trainCourse}}</span>
                </div>
            </div>
            <div class="singupForm">
                <div class="header">报名信息</div>

                <div v-for="(element, k) in textData" :key="k">
                    <div class="numBox">
                        <div>序号:{{k+1}}</div>
                        <div @click="delData(k)" class="delete" v-if="k!=0">
                            <i class="el-icon-remove-outline" /> 删减</div>
                    </div>

                    <div class="flexwarpBox">
                        <el-form v-for="(item, index) in element" :key="index" :model="item" ref="formData" class="itemBox" label-width="120px" @submit.native.prevent>
                            <div v-if="item.configType == 'input'">
                                <!-- style="width: 40%;" -->
                                <el-form-item :label="item.configName" :rules="[
                                {required:item.isRequired==1?true:false,message: '请输入', trigger: 'blur' ,pattern: item.configRegex}
                                ]">
                                    <el-input placeholder="请输入" v-model="item.inputValue"></el-input>
                                </el-form-item>
                            </div>
                            <div v-else-if="item.configType == 'radio'" class="radio">
                                <el-form-item :label="item.configName" :rules="[
                                                {
                                                required: item.isRequired==1?true:false,
                                                pattern: item.configRegex,
                                                message: item.message,trigger: 'change' ,
                                                },
                                                ]">
                                    <el-radio-group v-model="item.inputValue">
                                        <el-radio :name="option" v-for="(option,i) in item.configOptionList" :key="i" @click="radioFn(item,option,index)" :label="option">
                                            {{ option }}
                                        </el-radio>
                                    </el-radio-group>
                                </el-form-item>

                                <div v-if="item.children.length!=0">
                                    <div v-if="item.inputValue">
                                        <div v-for="(e,key) in item.children" :key=key>
                                            <div v-if="e.configType == 'input'&&item.inputValue==e.fatherValue">

                                                <el-form-item :label="e.configName" :rules="[
                                                {required:e.isRequired==1?true:false,message: '请输入', trigger: 'blur' ,pattern: e.configRegex}
                                                ]">
                                                    <el-input placeholder="请输入" v-model="e.inputValue"></el-input>
                                                </el-form-item>

                                            </div>
                                            <div v-if="e.configType == 'checkbox'&&item.inputValue==e.fatherValue">

                                                <el-form-item :label="e.configName" :rules="[
                                                {required:e.isRequired==1?true:false,message: '请选择', trigger: 'change' }
                                                ]">
                                                    <el-checkbox-group v-model="e.inputValueList">
                                                        <el-checkbox v-for="(l, k) in e.configOptionList" :label="l" :key="k" name="type">{{l}}</el-checkbox>
                                                    </el-checkbox-group>
                                                </el-form-item>
                                            </div>
                                            <div v-if="e.configType == 'radio'&&item.inputValue==e.fatherValue">

                                                <el-form-item :label="e.configName" :prop="e.inputValue" :rules="[
                                                {
                                                required: e.isRequired==1?true:false,
                                                pattern: e.configRegex,
                                                message: e.message,trigger: 'change' ,
                                                },
                                                ]">
                                                    <el-radio-group v-model="e.inputValue">
                                                        <el-radio :name="l" v-for="(l,k) in item.configOptionList" :key="k" :label="l">
                                                            {{ l }}
                                                        </el-radio>
                                                    </el-radio-group>
                                                </el-form-item>
                                            </div>
                                            <div v-if="e.configType == 'date'&&item.inputValue==e.fatherValue">

                                                <el-form-item :label="e.configName" :rules="[
                                                    {required:e.isRequired==1?true:false,message: '请选择日期', trigger: 'change' }
                                                    ]">
                                                    <el-date-picker v-model="e.inputValue" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:100%">
                                                    </el-date-picker>
                                                </el-form-item>
                                            </div>
                                            <div v-if="e.configType == 'select'&&item.inputValue==e.fatherValue" class="select">

                                                <el-form-item :label="e.configName" :rules="[
                                                        {required:e.isRequired==1?true:false,message: '请选择', trigger: 'change' ,pattern: e.configRegex}
                                                        ]">
                                                    <el-select v-model="e.inputValue" placeholder="请选择" style="width:100%">
                                                        <el-option v-for="(l,k) in e.configOptionList" :key="k" :label="l" :value="l">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                            </div>

                                        </div>
                                    </div>
                                    <div v-else>
                                        <div v-for="(e,key) in item.children" :key=key>
                                            <div v-for="(j,k) in radioList" :key="k">
                                                <div v-if="e.configType == 'input'&&j.option==e.fatherValue">

                                                    <el-form-item :label="e.configName" :rules="[
                                                        {required:e.isRequired==1?true:false,message: '请输入', trigger: 'blur' ,pattern: e.configRegex}
                                                        ]">
                                                        <el-input placeholder="请输入" v-model="e.inputValue"></el-input>
                                                    </el-form-item>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else-if="item.configType == 'checkbox'" class="checkbox">
                                <el-form-item :label="item.configName" :rules="[
                                                {required:item.isRequired==1?true:false,message: '请选择', trigger: 'change' }
                                                ]">
                                    <el-checkbox-group v-model="item.inputValueList">
                                        <el-checkbox v-for="(l, k) in item.configOptionList" :label="l" :key="k" name="type">{{l}}</el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                            </div>
                            <div v-else-if="item.configType == 'date'" class="date">

                                <el-form-item :label="item.configName" :rules="[
                                        {required:item.isRequired==1?true:false,message: '请选择日期', trigger: 'change' }
                                        ]">
                                    <el-date-picker v-model="item.inputValue" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:100%">
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                            <div v-else-if="item.configType == 'select'" class="select">

                                <el-form-item :label="item.configName" :rules="[
                                                        {required:item.isRequired==1?true:false,message: '请选择', trigger: 'change' ,pattern: item.configRegex}
                                                        ]">
                                    <el-select v-model="item.inputValue" placeholder="请选择" style="width:100%">
                                        <el-option v-for="(e,index) in item.configOptionList" :key="index" :label="e" :value="e">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>

                        </el-form>
                    </div>
                </div>
                <div class="btnwarp" v-if="audit!=2&&audit!=4&&audit!=1">
                    <div @click="addDomain" class="addbtn">
                        <i class="el-icon-circle-plus-outline" /> 增加报名人数</div>
                </div>
            </div>
            <!-- fapiao -->
            <div class="singupForm">
                <el-form ref="billForm" :model="BusBillBo" label-width="120px" class="demo-dynamic" @submit.native.prevent >
                    <div v-if="busCourseData.pay!='免费'">
                        <div class="makeoutInfoBox" v-if="busCourseData.activityPreStatus==2||busCourseData.openPayMent==2">
                            <div class="header">开票信息</div>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="开票种类" prop="billkind" :rules="billRules.billkind">
                                        <el-radio-group v-model="BusBillBo.billkind" @change="billkindFn" :disabled="disableFlag1">
                                            <el-radio label="增值税普通发票"></el-radio>
                                            <el-radio label="增值税专用发票"></el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" v-if="BusBillBo.billkind">
                                    <el-form-item label="开票类型" prop="billPathway" :rules="billRules.billPathway">
                                        <el-radio-group v-model="BusBillBo.billPathway" @change="billPathwayFn" :disabled="disableFlag2">
                                            <el-radio label="电子版"></el-radio>
                                            <el-radio label="纸质版"></el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <div v-if="BusBillBo.billkind">

                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="发票抬头" prop="signName" :rules="billRules.signName">
                                            <el-input placeholder="请输入发票抬头" v-model="BusBillBo.signName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="单位税号" prop="dutyParagraph" :rules="billRules.dutyParagraph">
                                            <el-input placeholder="请输入单位税号" v-model="BusBillBo.dutyParagraph"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <!-- 普通发票 -->
                                <div v-if="this.billkindFlag==1">
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="收票人" prop="takerName" :rules="billRules.takerName">
                                                <el-input placeholder="请输入收票人" v-model="BusBillBo.takerName"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="收票人电话" prop="takerPhone" :rules="billRules.takerPhone">
                                                <el-input placeholder="请输入收票人电话" v-model="BusBillBo.takerPhone"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="收票人邮箱" prop="takerEmail" :rules="billRules.takerEmail">
                                                <el-input placeholder="请输入收票人邮箱" v-model="BusBillBo.takerEmail"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="收票人地址" prop="takerAddress" :rules="billRules.takerAddress">
                                                <el-input placeholder="请输入收票人地址" v-model="BusBillBo.takerAddress"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </div>
                                <!-- 增值税发票 -->
                                <div v-else>
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="注册电话" prop="billPhone" :rules="billRules.billPhone">
                                                <el-input placeholder="请输入注册电话" v-model="BusBillBo.billPhone"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="注册地址" prop="billsite" :rules="billRules.billsite">
                                                <el-input placeholder="请输入注册地址" v-model="BusBillBo.billsite"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="开户银行" prop="bankName" :rules="billRules.bankName">
                                                <el-input placeholder="请输入开户银行" v-model="BusBillBo.bankName"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="银行账号" prop="bankUserName" :rules="billRules.bankUserName">
                                                <el-input placeholder="请输入银行账号" v-model="BusBillBo.bankUserName"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <el-form-item label="收票人" prop="takerName" :rules="billRules.takerName">
                                                <el-input placeholder="请输入收票人" v-model="BusBillBo.takerName"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="收票人电话" prop="takerPhone" :rules="billRules.takerPhone">
                                                <el-input placeholder="请输入收票人电话" v-model="BusBillBo.takerPhone"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="20">
                                        <el-col :span="12" v-if="billPathwayFlag==1">
                                            <el-form-item label="收票人邮箱" prop="takerEmail" :rules="billRules.takerEmail">
                                                <el-input placeholder="请输入收票人邮箱" v-model="BusBillBo.takerEmail"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12" v-else>
                                            <el-form-item label="收票人地址" prop="takerAddress" :rules="billRules.takerAddress">
                                                <el-input placeholder="请输入收票人地址" v-model="BusBillBo.takerAddress"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </div>
                            </div>

                        </div>
                        <div v-if="busCourseData.openPayMent==2&&busCourseData.pay!='免费'">
                            <div class="makeoutInfoBox">
                                <div class="header">上传缴费凭证
                                    <span class="seepay" @click="seePayFn">（ 查看收款信息 ）</span>
                                </div>
                                <div class="uploadbox">
                                    <el-form-item label="缴费凭证" label-width="120px" :rules="billRules.payVoucher">
                                        <el-upload accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="secondSuccessFn" :on-remove="secondRemoveFn" :action="actionUrl"
                                            :headers="headers" :file-list="fileList">
                                            <i class="el-icon-plus"></i>
                                        </el-upload>
                                    </el-form-item>
                                </div>
                                <el-form-item label="备注" label-width="120px">
                                    <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="remark" maxlength="50" show-word-limit />

                                </el-form-item>

                            </div>
                        </div>
                    </div>
                    <div class="formBtnBox">
                        <el-button type="primary" @click="submitFormFn()" :disabled='btnFlag' class="submitBtn" v-if="audit!=2&&audit!=4">{{audit==3?'提交':'信息变更确认'}}</el-button>
                        <el-button @click="submitdraft" class="cancelBtn" v-if="audit!=2&&audit!=4">取消报名</el-button>
                        <el-button @click="offmodalFn" class="returnBtn">返回</el-button>
                    </div>
                </el-form>

            </div>
        </div>
        <!-- 取消报名确定弹框 -->
        <el-dialog title="取消报名" width="720px" class="dialogWarp" :visible.sync="cancelVisible" :destroy-on-close="true" :close-on-click-modal='false'>
            <div class="dialogcenterbox">
                <div class="text1">取消报名是取消当前课程下该企业所有人员报名，请确定是否取消。若只是取消某一个人员报名，可以点击删除人员信息,选择该人员删除信息之后点击信息保存</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="okFn">确定</el-button>
                <el-button @click="cancelFn">取消</el-button>
            </span>
        </el-dialog>
        <!-- 收款信息 -->
        <el-dialog title="收款信息" :visible.sync="payVisible" width="50%" :before-close="payClose" :destroy-on-close="true" :append-to-body="true"
            :close-on-click-modal='false'>
            <div class="payBox">
                <img :src="imgSrc+busCourseData.receiveAccount" class="payImg" />
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
import { formErrorScroll, showMessage } from '@/utils'
export default {
    data() {
        return {
            radioList: [],
            // 发票信息
            BusBillBo: {
                billkind: '',//开票种类
                billPathway: '',//开票类型
                signName: '',//发票抬头
                dutyParagraph: '',//单位税号
                // 增值税发票
                billPhone: '',//注册电话
                billsite: '',//注册地址
                bankName: '',//开户银行
                bankUserName: '',//银行账号
                // 普通发票
                takerName: '',//收票人
                takerPhone: '',//收票人电话
                // 增值税-电子
                takerEmail: '',//收票人邮箱
                // 增值税-纸质
                takerAddress: '',//收票人地址
            },
            billRules: {
                billkind: [
                    { required: true, message: '请选择开票种类', trigger: 'change' }
                ],
                billPathway: [
                    { required: true, message: '请选择开票类型', trigger: 'change' }
                ],
                signName: [
                    { required: true, message: '发票抬头不能为空', trigger: 'blur' }
                ],
                dutyParagraph: [
                    { required: true, message: '单位税号不能为空', trigger: 'blur' }
                ],
                billPhone: [
                    {
                        required: true,
                        message: '请输入注册电话', trigger: 'blur',
                    },
                    // { pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, trigger: 'blur', message: '请输入正确的联系人手机号码', }
                ],
                billsite: [
                    {
                        required: true,
                        message: '请输入注册地址', trigger: 'blur'
                    },
                ],

                bankName: [
                    {
                        required: true,
                        message: '请输入开户银行', trigger: 'blur'
                    },
                ],
                bankUserName: [
                    {
                        required: true,
                        message: '请输入银行账号', trigger: 'blur'
                    },
                ],
                takerName: [
                    { required: true, message: '请输入收票人', trigger: 'blur' }
                ],
                takerPhone: [
                    { required: true, message: '请输入收票人电话', trigger: 'blur' },
                    { pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, trigger: 'blur', message: '请输入正确的手机号码', }
                ],
                takerEmail: [
                    { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                ],
                takerAddress: [
                    { required: true, message: '请输入收票人地址', trigger: 'blur' },
                ],
                payVoucher: [
                    { required: true, message: '请上传', trigger: 'change' }
                ],
            },
            formrules: {},
            actionUrl: process.env.VUE_APP_GATEWAY + '/upload/addfile',
            headers: null,
            // 凭证
            fileList: [],
            remark: '',
            // 修改
            busCourseData: {},
            userId: JSON.parse(sessionStorage.getItem('userInfo')).userId,
            textData: [],
            // 开票种类
            billkindFlag: null,
            billPathwayFlag: null,
            imgSrc: srcUrl,
            disableFlag1: false,
            disableFlag2: false,
            changeStatus: null,
            trainId: "",
            audit: '',
            cancelVisible: false,
            // isappLyFlag: true,
            btnFlag: false,
            payVisible: false
        }
    },
    created() {
        this.trainId = this.$route.query.id || this.$route.params.id;
        // 获取课程信息
        this.getSingleBusCourseFn(this.trainId)
        // 获取报名配置信息
        this.getApplyListFn()

    },
    methods: {
        async getSingleBusCourseFn(trainId) {
            let res = await httpService.getSingleBusCourse(trainId);
            if (res.code == 200) {
                this.busCourseData = res.result || {}
                this.audit = res.result.audit
                if (this.busCourseData.openPayMent == 2) {
                    // 获取发票信息
                    this.getBillInfo()
                    // 获取凭证相关
                    this.getVoucherFn()
                }
            } else {
                this.$message.error(res.message);
            }
        },
        showBillFn(billTypes) {
            if (billTypes.length == 1) {
                let billType = billTypes.join('')
                if (billType == 1) {
                    this.BusBillBo.billkind = '增值税普通发票'
                    this.BusBillBo.billPathway = '电子版'
                    this.disableFlag1 = true
                    this.disableFlag2 = true
                    this.billkindFlag = 1
                } else if (billType == 2) {
                    this.BusBillBo.billkind = '增值税专用发票'
                    this.BusBillBo.billPathway = '纸质版'
                    this.disableFlag1 = true
                    this.disableFlag2 = true
                    this.billkindFlag = 2
                }
                else if (billType == 3) {
                    this.BusBillBo.billkind = '增值税专用发票'
                    this.BusBillBo.billPathway = '电子版'
                    this.disableFlag1 = true
                    this.disableFlag2 = true
                    this.billkindFlag = 2

                }
                else if (billType == 4) {
                    this.BusBillBo.billkind = '增值税普通发票'
                    this.BusBillBo.billPathway = '纸质版'
                    this.disableFlag1 = true
                    this.disableFlag2 = true
                    this.billkindFlag = 1
                }
                // 4 增值税普通纸质发票

            } else if (billTypes.length == 2) {
                let billType = billTypes
                if (billType.includes("1") && billType.includes("2")) {
                    this.changeStatus = 12
                } else if (billType.includes("1") && billType.includes("3")) {
                    this.BusBillBo.billPathway = '电子版'
                    this.disableFlag2 = true
                }
                // 1 4 增值税普通发票
                else if (billType.includes("1") && billType.includes("4")) {
                    this.BusBillBo.billkind = '增值税普通发票'
                    this.disableFlag1 = true
                }
                else if (billType.includes("2") && billType.includes("3")) {
                    this.BusBillBo.billkind = '增值税专用发票'
                    this.disableFlag1 = true
                }
                // 2专用纸质 4 增值税普通纸质
                else if (billType.includes("2") && billType.includes("4")) {
                    this.BusBillBo.billPathway = '纸质版'
                    this.disableFlag2 = true
                }
                //  3专用电子 4 增值税普通纸质
                else if (billType.includes("3") && billType.includes("4")) {
                    this.changeStatus = 34
                }
            }
            else if (billTypes.length == 3) {
                let billType = billTypes
                if (billType.includes("1") && billType.includes("2") && billType.includes("3")) {
                    this.changeStatus = 123
                }
                else if (billType.includes("1") && billType.includes("2") && billType.includes("4")) {
                    this.changeStatus = 124
                }
                else if (billType.includes("2") && billType.includes("3") && billType.includes("4")) {
                    this.changeStatus = 234
                }
                else if (billType.includes("1") && billType.includes("4") && billType.includes("3")) {
                    this.changeStatus = 143
                }
            }
        },
        radioFn(item, option, index) {
            if (item.children.length != 0) {
                if (this.radioList.length != 0) {
                    this.radioList.forEach((e => {
                        if (e.templateId == item.templateId) {
                            e.option = option
                        } else {
                            let obj = {
                                templateId: item.templateId,
                                option: option
                            }
                            this.radioList.push(obj)
                        }
                    }))
                } else {
                    let arr = []
                    let obj = {
                        templateId: item.templateId,
                        option: option,
                    }
                    arr.push(obj)
                    this.radioList = arr
                }
                this.radioList = this.unique(this.radioList)
            }
        },
        // 发票
        // 开票种类
        billkindFn(value) {
            if (value == '增值税普通发票') {
                this.billkindFlag = 1
            } else {
                this.billkindFlag = 2
                if (this.BusBillBo.billPathway) {
                    if (this.BusBillBo.billPathway == '电子版') {
                        this.billPathwayFlag = 1
                    } else {
                        this.billPathwayFlag = 2
                    }
                }
            }
            if (this.changeStatus == 12) {
                if (this.billkindFlag == 1) {
                    this.BusBillBo.billPathway = '电子版'
                    this.disableFlag2 = true
                } else {
                    this.BusBillBo.billPathway = '纸质版'
                    this.disableFlag2 = true
                }
            } else if (this.changeStatus == 34) {
                if (this.billkindFlag == 1) {
                    this.BusBillBo.billPathway = '纸质版'
                    this.disableFlag2 = true
                } else {
                    this.BusBillBo.billPathway = '电子版'
                    this.disableFlag2 = true
                }
            }
            //  1普通电子 2专用纸质  3专用电子 4普通纸质
            else if (this.changeStatus == 123) {
                if (this.billkindFlag == 1) {
                    this.BusBillBo.billPathway = '电子版'
                    this.disableFlag2 = true
                } else {
                    this.BusBillBo.billPathway = ""
                    this.disableFlag2 = false
                }
            } else if (this.changeStatus == 124) {
                if (this.billkindFlag == 2) {
                    this.BusBillBo.billPathway = '纸质版'
                    this.disableFlag2 = true
                } else {
                    this.BusBillBo.billPathway = ""
                    this.disableFlag2 = false
                }

            } else if (this.changeStatus == 143) {
                if (this.billkindFlag == 2) {
                    this.BusBillBo.billPathway = '电子版'
                    this.disableFlag2 = true
                } else {
                    this.BusBillBo.billPathway = ""
                    this.disableFlag2 = false
                }

            } else if (this.changeStatus == 234) {
                if (this.billkindFlag == 1) {
                    this.BusBillBo.billPathway = '纸质版'
                    this.disableFlag2 = true
                } else {
                    this.BusBillBo.billPathway = ""
                    this.disableFlag2 = false
                }
            }
        },
        // 开票类型
        billPathwayFn(value) {
            if (this.billkindFlag == 2) {
                if (value == "电子版") {
                    this.billPathwayFlag = 1
                } else {
                    this.billPathwayFlag = 2
                }
            }
        },

        // 获取报名信息
        async getApplyListFn() {
            let { code, message, result } = await httpService.getApplyList(this.trainId, this.userId);
            if (code == 200) {
                let dataList = result.applyOptionList
                let formList = []
                result.applyOptionList.forEach((element) => {
                    element.forEach(item => {
                        let obj = {}
                        // JSON.stringify(item.configRegex)=="{}"
                        // 添加验证
                        if (item.configRegex && item.isRequired == 1) {
                            // item.configRegex = new RegExp(item.configCode)
                            // item.message = "请输入正确格式"
                        } else {
                            item.configRegex = ""
                        }
                        if (item.configType == 'input') {
                            if (!item.inputValue) {
                                item.inputValue = ''
                            }
                        }
                        else if (item.configType == 'radio') {
                            if (!item.inputValue) {
                                item.inputValue = ''
                            }
                            if (item.children.length != 0) {
                                item.childrenList = item.children
                                item.children.forEach(e => {
                                    if (e.configRegex && e.isRequired == 1) {
                                        // e.configRegex = new RegExp(e.configCode)
                                    } else {
                                        e.configRegex = ""
                                    }
                                    e.fatherConfigId = item.configeId//添加
                                    if (e.configType == 'checkbox') {

                                        if (!e.inputValueList || e.inputValueList.length == 0) {
                                            e.inputValueList = [];
                                        }

                                    } else {
                                        if (!e.inputValue) {
                                            e.inputValue = ''
                                        }

                                    }
                                })
                            }
                            // item.inputValue = ''
                        } else if (item.configType == 'date') {
                            if (!item.inputValue) {
                                item.inputValue = ''
                            }
                        } else if (item.configType == 'select') {
                            if (!item.inputValue) {
                                item.inputValue = ''
                            }
                        }
                        else if (item.configType == 'checkbox') {
                            if (!item.inputValueList || item.inputValueList.length == 0) {
                                item.inputValueList = [];
                            }
                        }
                    });
                })
                this.textData = dataList
                this.idObj = {
                    trainId: result.trainId,
                    userId: result.userId,
                }
                if (this.busCourseData.activityPreStatus == 2) {
                    this.getBillInfo()
                }
            } else {
                this.$message.error(message);
            }
        },
        // 获取发票信息
        async getBillInfo() {
            let { code, result, message } = await httpService.getbusBillInfo(this.trainId, this.userId);
            if (code == 200) {
                this.BusBillBo = result
                if (result.billkind == '增值税普通发票') {
                    this.billkindFlag = 1
                } else {
                    this.billkindFlag = 2
                    if (result.billPathway == '电子版') {
                        this.billPathwayFlag = 1
                    } else {
                        this.billPathwayFlag = 2
                    }
                }
                // 发票展示
                this.showBillFn(this.busCourseData.billTypes)
            } else {
                this.$message.error(res.message);
            }
        },
        // 获取凭证
        async getVoucherFn() {
            let res = await httpService.getVoucher(this.trainId, this.userId);
            if (res.code == 200) {
                if (res.result.payVoucher) {
                    let data = res.result.payVoucher.split(',')
                    let fileList = []
                    if (data.length != 0) {
                        data.forEach(e => {
                            let obj = {
                                name: e,
                                url: this.imgSrc + e,
                                response: e,
                            }
                            fileList.push(obj)
                        });
                    }
                    this.fileList = fileList
                    this.remark = res.result.remark
                }

            } else {
                this.$message.error(res.message);
            }
        },

        delData(index) {
            this.textData.splice(index, 1)
        },
        addDomain() {
            let arr = this.textData.slice(0, 1)[0];
            arr = arr.map((e) => {
                if (e.children.length != 0) {
                    let childrenItem = e.children.map((item) => {
                        if (item.configType == "checkbox") {
                            return {
                                ...item,
                                inputValueList: [],
                            };
                        } else {
                            return {
                                ...item,
                                inputValue: "",
                            };
                        }
                    });

                    return {
                        ...e,
                        children: childrenItem,
                        inputValueList: [],
                        inputValue: "",
                    };
                }

                if (e.configType == "checkbox") {
                    return {
                        ...e,
                        inputValueList: [],
                    };
                } else {
                    return {
                        ...e,
                        inputValue: "",
                    };
                }
            });

            this.textData.push(arr);
        },

        // 上传
        secondSuccessFn(res, file, fileList) {
            if (res.code == 200) {
                this.fileList = fileList
            }
        },
        secondRemoveFn(file, fileList) {
            this.fileList = fileList
        },
        async submitFormFn() {
            let dataForm = JSON.parse(JSON.stringify(this.textData));
            // 验证是否填完
            let flag = true;
            dataForm.forEach((scoreVaule, index) => {
                // 判断必填项是否全部填完
                scoreVaule.some((item) => {
                    if (item.configType == "radio") {
                        if (item.configType == "radio" && item.isRequired == 1 && item.inputValue == '') {
                            flag = false;
                            showMessage(`第${index + 1}个报名信息必填项未填写完！`)
                            return false;
                        } else {
                            if (item.children.length != 0) {
                                item.children.some(e => {
                                    if (e.fatherValue == item.inputValue) {
                                        if (e.configType == "input" && e.isRequired == 1 && e.inputValue == '') {
                                            flag = false;
                                            showMessage(`第${index + 1}个报名信息必填项未填写完！`)
                                            return false;
                                        } else if (e.configType == "radio" && e.isRequired == 1 && e.inputValue == '') {
                                            flag = false;
                                            showMessage(`第${index + 1}个报名信息必填项未填写完！`)
                                            return false;
                                        } else if (e.configType == "checkbox" && e.isRequired == 1 && e.inputValueList.length == 0) {
                                            flag = false;
                                            showMessage(`第${index + 1}个报名信息必填项未填写完！`)
                                            return false;
                                        } else if (e.configType == "date" && e.isRequired == 1 && e.inputValue == '') {
                                            flag = false;
                                            showMessage(`第${index + 1}个报名信息必填项未填写完！`)
                                            return false;
                                        } else if (e.configType == "select" && e.isRequired == 1 && e.inputValue == '') {
                                            flag = false;
                                            showMessage(`第${index + 1}个报名信息必填项未填写完！`)
                                            return false;
                                        }
                                    }
                                })
                            }
                        }
                    }
                    else if (item.configType == "checkbox" && item.isRequired == 1 && item.inputValueList.length == 0) {
                        flag = false;
                        showMessage(`第${index + 1}个报名信息必填项未填写完！`)
                        return false;
                    } else if (item.configType == "input" && item.isRequired == 1 && item.inputValue == "") {
                        flag = false;
                        showMessage(`第${index + 1}个报名信息必填项未填写完！`)
                        return false;
                    } else if (item.configType == "date" && item.isRequired == 1 && item.inputValue == "") {
                        flag = false;
                        showMessage(`第${index + 1}个报名信息必填项未填写完！`)
                        return false;
                    } else if (item.configType == "select" && item.isRequired == 1 && item.inputValue == "") {
                        flag = false;
                        showMessage(`第${index + 1}个报名信息必填项未填写完！`)
                        return false;
                    }
                });

            });
            let validate = false, childrenvalidate = false
            let num = 0, validateNum = 0
            let childrenNum = 0, childrenValidateNum = 0
            // 校验
            if (flag) {
                dataForm.forEach((element) => {
                    element.forEach(item => {
                        if (item.configType == "input" && item.isRequired == 1) {
                            if (item.configRegex) {
                                num = num + 1
                                item.configRegex = new RegExp(item.configRegex)
                                if (!item.configRegex.test(item.inputValue)) {
                                    showMessage(`${item.configName}请填写正确格式！`)
                                    validate = false
                                    return
                                } else {
                                    validateNum = validateNum + 1
                                    return
                                }
                            }
                        }
                        if (item.children.length != 0) {
                            item.children.forEach(ele => {
                                if (ele.configType == "input" && ele.isRequired == 1 && item.inputValue == ele.fatherValue) {
                                    if (ele.configRegex) {
                                        childrenNum = childrenNum + 1
                                        ele.configRegex = new RegExp(ele.configRegex)
                                        if (!ele.configRegex.test(ele.inputValue)) {
                                            showMessage(`${ele.configName}请填写正确格式！`)
                                            validate = false
                                            return
                                        } else {
                                            childrenValidateNum = childrenValidateNum + 1
                                            return
                                        }
                                    }
                                }
                            })
                        }

                    })
                });
            } else {
                return
            }
            if (num == validateNum && childrenValidateNum == childrenNum) {
                validate = true
            }
            // 组装数据
            let applyPersonInfoBo = [];
            if (validate) {
                dataForm.forEach((element) => {
                    let childResult = []
                    element = element.map((item, index) => {
                        if (item.configType == "radio") {
                            if (item.children.length != 0) {
                                item.children.forEach((e, i) => {
                                    if (e.fatherValue == item.inputValue) {
                                        if (
                                            e.configType == "checkbox" &&
                                            e.inputValueList.length != 0
                                        ) {
                                            childResult.push({
                                                configName: e.configName,
                                                configeId: e.configeId,
                                                inputValueList: e.inputValueList,
                                                isRequired: e.isRequired,
                                            });
                                        } else if (e.configType != "checkbox" && e.inputValue) {
                                            childResult.push({
                                                configName: e.configName,
                                                configeId: e.configeId,
                                                inputValue: e.inputValue,
                                                isRequired: e.isRequired,
                                            });
                                        }
                                    }
                                });
                            }

                            return {
                                configName: item.configName,
                                configeId: item.configeId,
                                inputValue: item.inputValue,
                                isRequired: item.isRequired,
                            };
                        } else if (item.configType == "input") {
                            return {
                                configName: item.configName,
                                configeId: item.configeId,
                                inputValue: item.inputValue,
                                isRequired: item.isRequired,
                            };
                        } else if (item.configType == "checkbox") {
                            return {
                                configName: item.configName,
                                configeId: item.configeId,
                                inputValueList: item.inputValueList,
                                isRequired: item.isRequired,
                            };
                        } else if (item.configType == "date") {
                            return {
                                configName: item.configName,
                                configeId: item.configeId,
                                inputValue: item.inputValue,
                                isRequired: item.isRequired,
                            };
                        } else if (item.configType == "select") {
                            return {
                                configName: item.configName,
                                configeId: item.configeId,
                                inputValue: item.inputValue,
                                isRequired: item.isRequired,
                            };
                        }
                    });

                    applyPersonInfoBo.push([...element, ...childResult]);
                });
            } else {
                return
            }
            // console.log('进入提交');

            // 支持修改报名信息  || !this.isappLyFlag
            if (this.busCourseData.audit == 0 || this.busCourseData.audit == 3) {
                this.btnFlag = true //要放
                let { code, message } = await httpService.addApplyPerson({
                    applyPersonInfoBo,
                    trainId: this.idObj.trainId,
                    userId: this.idObj.userId,
                });
                if (code == 200) {
                    this.btnFlag = false
                    // 提交报名信息
                    if (
                        this.busCourseData.activityPreStatus == 2 || this.busCourseData.openPayMent == 2 &&
                        this.busCourseData.pay != "免费"
                    ) {
                        this.$refs.billForm.validate(async (valid) => {
                            if (valid) {
                                let billData = JSON.parse(JSON.stringify(this.BusBillBo))
                                billData.trainId = this.idObj.trainId,
                                    billData.userId = this.idObj.userId
                                this.btnFlag = true
                                let billResult = await httpService.addbusBill(billData);

                                if (billResult.code == 200) {
                                    this.btnFlag = false
                                    // 上传凭证
                                    if (this.busCourseData.openPayMent == 2) {
                                        //   fileList: [],
                                        // remark: '',
                                        if (this.fileList.length == 0) {

                                            this.$message({
                                                message: '请先上传缴费凭证！',
                                                type: 'warning'
                                            });
                                            return;
                                        }
                                        let payVoucher = [];
                                        this.fileList.forEach((item) => {
                                            if (item.response.result) {
                                                payVoucher.push(item.response.result);
                                            } else {
                                                payVoucher.push(item.response);
                                            }
                                        });
                                        this.btnFlag = true
                                        let res = await httpService.addVoucher({
                                            payVoucher: payVoucher.join(","),
                                            remark: this.remark,
                                            trainId: this.idObj.trainId,
                                            userId: this.idObj.userId,
                                        });

                                        if (res.code == 200) {
                                            this.btnFlag = false
                                            this.$message({
                                                message: '提交成功',
                                                type: 'success'
                                            });
                                            this.$router.push({
                                                path: "/account-center/train-course",
                                            });
                                        } else {
                                            this.btnFlag
                                            this.$message({
                                                message: res.message,
                                                type: 'error'
                                            });
                                        }
                                    } else {
                                        this.$message({
                                            message: '提交成功',
                                            type: 'success'
                                        });
                                        this.$router.push({
                                            path: "/account-center/train-course",
                                        });
                                    }
                                } else {
                                    this.btnFlag
                                    this.$message({
                                        message: billResult.message,
                                        type: 'error'
                                    });
                                }
                            } else {
                                return false
                            }
                        })

                    } else {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                        this.$router.push({
                            path: "/account-center/train-course",
                        });
                    }
                } else {
                    this.btnFlag = false
                    this.$message({
                        message: message,
                        type: 'error'
                    });
                }
            }
            // 提交发票信息
            else {
                if (this.busCourseData.activityPreStatus == 2 || this.busCourseData.openPayMent == 2 && this.busCourseData.pay != "免费") {
                    this.$refs.billForm.validate(async (valid) => {
                        if (valid) {
                            let billData = JSON.parse(JSON.stringify(this.BusBillBo))
                            billData.trainId = this.idObj.trainId,
                                billData.userId = this.idObj.userId
                            this.btnFlag = true
                            let billResult = await httpService.addbusBill(billData);

                            if (billResult.code == 200) {
                                this.btnFlag = false
                                // 上传凭证
                                if (this.busCourseData.openPayMent == 2) {
                                    //   fileList: [],
                                    // remark: '',
                                    if (this.fileList.length == 0) {

                                        this.$message({
                                            message: '请先上传缴费凭证！',
                                            type: 'warning'
                                        });
                                        return;
                                    }
                                    let payVoucher = [];
                                    this.fileList.forEach((item) => {
                                        if (item.response.result) {
                                            payVoucher.push(item.response.result);
                                        } else {
                                            payVoucher.push(item.response);
                                        }
                                    });
                                    this.btnFlag = true
                                    let res = await httpService.addVoucher({
                                        payVoucher: payVoucher.join(","),
                                        remark: this.remark,
                                        trainId: this.idObj.trainId,
                                        userId: this.idObj.userId,
                                    });

                                    if (res.code == 200) {
                                        this.btnFlag = false
                                        this.$message({
                                            message: '提交成功',
                                            type: 'success'
                                        });
                                        this.$router.push({
                                            path: "/account-center/train-course",
                                        });
                                    } else {
                                        this.btnFlag = false
                                        this.$message({
                                            message: res.message,
                                            type: 'error'
                                        });
                                    }
                                } else {
                                    this.$message({
                                        message: '提交成功',
                                        type: 'success'
                                    });
                                    this.$router.push({
                                        path: "/account-center/train-course",
                                    });
                                }
                            } else {
                                this.btnFlag = false
                                this.$message({
                                    message: billResult.message,
                                    type: 'error'
                                });
                            }
                        } else {
                            return false
                        }
                    })
                } else {
                    this.$message({
                        message: '提交成功',
                        type: 'success'
                    });
                    this.$router.push({
                        path: "/account-center/train-course",
                    });
                }
            }
        },
        // 取消报名
        submitdraft() {
            this.cancelVisible = true
        },
        // 确定取消
        async okFn() {
            let { code, message, result } = await httpService.deleteApply(this.trainId, this.userId);
            if (code == 200) {
                this.cancelVisible = false
                this.$message({
                    message: '取消报名成功',
                    type: 'success'
                });
                this.$router.push({
                    path: "/account-center/train-course",
                });
            } else {
                this.$message({
                    message: message,
                    type: 'error'
                });
            }

        },
        cancelFn() {
            this.cancelVisible = false
        },
        // 返回
        offmodalFn() {
            this.$router.push({
                path: "/account-center/train-course",
            });
            // this.$refs[formName].resetFields();
        },
        seePayFn() {
            this.payVisible = true
        },
        payClose() {
            this.payVisible = false
        }

    }
}
</script>
<style lang="less" scoped>
/deep/.payBox {
	padding: 10px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-content: center;
	align-items: center;
	.payImg {
		max-width: 100%;
	}
}
.CourseApplyDetailsWarp {
	.seepay {
		color: #0083ff;
		margin-left: 0px;
		cursor: pointer;
	}
	display: flex;
	flex-direction: row;
	padding: 30px 0 0 30px;
	box-sizing: border-box;

	.titleBox {
		width: 180px;
		font-size: 24px;
		font-weight: bold;
		line-height: 24px;
		color: #43424b;
	}
	/deep/.singupdialogcenter {
		padding: 0px 200px 0px 0px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-items: center;
		h3 {
			font-size: 22px;
			font-weight: bold;
			line-height: 32px;
			color: #333333;
			margin-bottom: 32px;
		}

		.courseBox1 {
			width: 100%;
			display: flex;
			flex-direction: row;
			justify-content: center;
			padding-bottom: 32px;
			border-bottom: 1px solid #dddddd;
			margin-bottom: 20px;
			.courseinfo {
				margin: 0 52px;
				font-size: 16px;
				line-height: 54px;
				color: #333333;
				.text {
					font-size: 16px;
					margin-right: 20px;
					line-height: 54px;
					color: #a6a9b7;
				}
			}
		}
		/deep/.el-checkbox__inner {
			border-radius: 50%;
		}
		.singupForm {
			width: 100%;
			.numBox {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				padding: 4px 6px 4px 12px;
				align-content: center;
				align-items: center;
				font-size: 14px;
				margin: 18px 0 10px 0;
				width: 100%;
				.delete {
					color: #ff3c3c;
					margin: 0 20px;
					cursor: pointer;
				}
			}
			.flexwarpBox {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;
				width: 100%;
				align-content: center;
				align-items: center;
				// justify-content: center;
				.itemBox {
					width: 48%;
					&:nth-child(2n) {
						margin-left: 2%;
					}
				}
			}
			.btnwarp {
				margin-top: 16px;
				font-size: 16px;
				line-height: 54px;
				display: flex;
				flex-direction: row;
				justify-content: center;

				.icon {
					margin-right: 5px;
				}
				.addbtn {
					color: #0083ff;
					margin: 0 20px;
					cursor: pointer;
				}
				.deletebtn {
					color: #ff3c3c;
					margin: 0 20px;
					cursor: pointer;
				}
			}
			.singupInfobox {
				padding-bottom: 32px;
				border-bottom: 1px solid #dddddd;
				margin-bottom: 20px;
				padding: 0 60px;
				.headerbox {
					height: 24px;
					font-size: 18px;
					font-weight: bold;
					line-height: 24px;
					color: #43424b;
					margin-bottom: 16px;
				}
				.header {
					margin-bottom: 12px;
				}
				.btnwarp {
					font-size: 16px;
					line-height: 54px;
					display: flex;
					flex-direction: row;
					justify-content: center;

					.icon {
						margin-right: 5px;
					}
					.addbtn {
						color: #0083ff;
						margin: 0 20px;
						cursor: pointer;
					}
					.deletebtn {
						color: #ff3c3c;
						margin: 0 20px;
						cursor: pointer;
					}
				}
			}
			.makeoutInfoBox {
				border-bottom: 1px solid #dddddd;
				margin-bottom: 20px;
				padding: 0 60px 0px 60px;
				.header {
					height: 24px;
					font-size: 18px;
					font-weight: bold;
					line-height: 24px;
					color: #43424b;
					margin-bottom: 16px;
				}
			}
			.makeoutInfoBox2 {
				margin-bottom: 20px;
				padding: 0 60px 0px 60px;
				.header {
					height: 24px;
					font-size: 18px;
					font-weight: bold;
					line-height: 24px;
					color: #43424b;
					margin-bottom: 16px;
				}
			}
			.formBtnBox {
				display: flex;
				fill-opacity: row;
				justify-content: center;
				.submitBtn {
					width: 152px;
					height: 40px;
					background: #349cff;
					margin: 0 20px;
				}
				.cancelBtn {
					width: 152px;
					height: 40px;
					background: #ffc56d;
					margin: 0 20px;
					color: #fff;
					border: 1px solid #ffc56d;
				}
				.returnBtn {
					width: 152px;
					height: 40px;
					border: 1px solid #a6a9b7;
					border-radius: 5px;
					margin: 0 20px;
				}
			}
		}
	}
	/deep/.dialogcenterbox {
		padding: 0px 0 90px 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		.text1 {
			font-size: 18px;
			line-height: 32px;
			color: #333333;
			margin: 46px 0;
		}
	}
}
</style>


